<template>
  <v-navigation-drawer id="app-drawer" v-model="showSideBar" :app="true" :mini-variant.sync="mini" light left floating persistent width="260" mobile-breakpoint="910" expand-on-hover>
    <v-list>
      <v-list-item name="topBar" id="topbar" @click="navToPage('/')">
        <v-list-item-avatar color="white" tile height="50" width="50">
          <v-img :src="logo" height="50" contain />
        </v-list-item-avatar>
        <v-list-item-title class="title">CRM</v-list-item-title>
      </v-list-item>

      <v-list-item class="px-2">
        <v-list-item-avatar>
          <img :src="getUser.imageURL" />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title class="body-1">{{
            getUser.email
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-divider />
    
    <v-list>
      <div v-for="(parentItem, i) in links" :key="i">
        <v-list-item v-if="!parentItem.subLinks" @click="navToPage(parentItem.to)" :class="linkActive(parentItem.to) ? 'v-list-item--active' : ''">
          <v-list-item-icon>
            <v-icon>{{ parentItem.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ parentItem.text }}</v-list-item-title>
        </v-list-item>

        <v-list-group v-else :prepend-icon="parentItem.icon" no-action>
          <template v-slot:activator>
            <v-list-item-title>{{ parentItem.text }}</v-list-item-title>
          </template>
          <v-list-item v-for="(childItem, i) in parentItem.subLinks" :key="i" @click="navToPage(childItem.to)" :class="linkActive(childItem.to) ? 'v-list-item--active' : ''">
            <v-list-item-icon>
              <v-icon>{{ childItem.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ childItem.text }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </div>
    </v-list>

    <template v-slot:append>
      <v-list>
        <v-list-item v-if="isLoggedIn" @click="logout">
          <v-list-item-action>
            <v-icon>logout</v-icon>
          </v-list-item-action>
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item>
      </v-list>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mdiPhone,mdiCogs,mdiAccountBoxMultiple,mdiGavel,mdiFinance,mdiViewList,mdiAccountDetails,mdiAccountMultipleOutline, mdiPhoneSettings, mdiCashMultiple,mdiTicketConfirmationOutline, mdiContacts,mdiCurrencyGbp, mdiRouterWireless, mdiAccountCash, mdiPackageVariantClosed, mdiTextBoxOutline } from '@mdi/js';
import { mapActions, mapGetters } from "vuex";

export default {
  data: () => ({
    showSideBar: true,
    logo: "https://images.ctfassets.net/n5o9iyd7qmbj/5suzKBTBh2n7qho8jye2Sd/5e0aad91359e4cc4057039396c1d7677/bOnline_App_Icon.svg",
    responsive: false,
    mini: true,
  }),

  computed: {
    ...mapGetters('globals',['hasUserGotRole']),
    ...mapGetters("auth", ["isLoggedIn", "getUser"]),
    
    links(){

      let menuItems =  [
        {to: "/tickets/",icon: mdiTicketConfirmationOutline,text: "Tickets"},
        {to: "/daily/",icon: mdiAccountDetails,text: "Daily Leads"},
        {to: "/demos/",icon: mdiPackageVariantClosed,text: "Demos"},
        {to: "/accounts/",icon: mdiAccountBoxMultiple,text: "Billing Accounts"},
        {to: "/products/",icon: mdiAccountMultipleOutline,text: "Products"},
        {to: "/number-transfers/",icon: mdiPhoneSettings,text: "Numbers Transfer"},
        {to: '/products/telco', icon: mdiRouterWireless, text: 'Telco Workflow' },
        {
          icon: mdiGavel,
          text: "Retention",
          subLinks: [
            {to: "/retention/",icon: mdiViewList,text: "List"},
            {to: "/retention/reports/",icon: mdiFinance,text: "Reports"}
          ]
        },
        {to: "/credit-notes/",icon: mdiCashMultiple,text: "Credit Notes"},
        {to: '/comms/', icon: mdiContacts, text: 'Comms'},
        {to: '/credit-control/', icon: mdiAccountCash, text: 'Credit Control'}
      ];

      if(this.hasUserGotRole('number-pool-refresh')){
        menuItems.unshift({
          icon: mdiCogs,
          text: "Admin",
          subLinks: [
            {to: "/admin/number-pool/",icon: mdiPhone,text: "Number pool"}
          ]
        });
      }

      if(this.hasUserGotRole('marketing-team')){
        menuItems.push({to: "/marketing/cpl/",icon: mdiCurrencyGbp,text: "CPL Dashboard"},);
      }

      if(this.hasUserGotRole('can-access-0n-dashboard')) {
        const ledger = { 
          icon: mdiTextBoxOutline,
          text: 'Ledger',
          subLinks: [{to: "/ledger/on-dashboard/",icon: mdiTextBoxOutline,text: "ON Dashboard"}],
        }
        menuItems.push(ledger);
      }

      return menuItems;
    },
  },

  methods: {
    ...mapActions("auth", ["logoutUser"]),

    logout() {
      this.logoutUser().then(()=>{
        this.$router.push({ name: "login" });
      });
    },

    onSuccess(googleUser) {
      this.setUser(googleUser).then(() => {
        this.$router.push({ name: "default" });
      });
    },

    onFailure(e) {
      return e;
    },

    navToPage(page){
      if(this.$router.currentRoute.name==='retentionleadview'){
        if(/localhost/.test(window.location.href)){
          window.location.href=page;
        }else{
          window.location.href=`${page}`;
        }
      } else {
        this.$router.push(`${page}`);
      }
    },

    linkActive(page) {
      return page === this.$route.path;
    }
  },
};
</script>

<style lang="scss" scoped>
#app-drawer {
  box-shadow: 1px 0px 4px 0px rgba(0, 0, 0, 0.1);
  .v-image__image--contain {
    top: 9px;
    height: 60%;
  }
  .v-list-item {
    margin-left: 0px;
    margin-right: 0px;
  }

  .v-list {
    padding-top: 0px;
  }

  .search-input {
    margin-bottom: 30px !important;
    padding-left: 0px;
    padding-right: 0px;
  }

  .active {
    background-color: #42CCCC;
  }

  div.v-responsive.v-image > div.v-responsive__content {
    overflow-y: auto;
  }

  #topbar {
    height: 69px;
    border-bottom: 5px solid #42CCCC;
    padding-left: 9px;
  }
}
</style>
